module.exports = __webpack_public_path__ + "static/img/far2.d44db9cb.png";